import "./index.css";

function Contact() {
  return (
    <div className="contact-container">
      <div className="section section--contact" id="contact">
        <div className="section-heading">
          <h2>CONTACT ME</h2>
        </div>
        <div className="sub-section sub-section--contact">
          <div className="contact-card">
            <div className="contact-card__icon">
              <i className="fa fa-map-marker"></i>
            </div>
            <div className="contact-card__content">
              <h3>Location</h3>
              <p>Pune, Maharashtra 411047, IN</p>
            </div>
          </div>
          <div className="contact-card">
            <div className="contact-card__icon">
              <i className="fa fa-envelope"></i>
            </div>
            <div className="contact-card__content">
              <h3>Email</h3>
              <a href="mailto:janraorishikesh@gmail.com">
                janraorishikesh@gmail.com
              </a> 
            </div>
          </div>
          <div className="contact-card">
            <div className="contact-card__icon">
              <i className="fa fa-phone"></i>
            </div>
            <div className="contact-card__content">
              <h3>Phone</h3>
              <a href="tel:+918390787106">
                +91 8390787106
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="section section--contact-form" id="hireme">
        <div className="sub-section sub-section--contact">
          <input type="text" placeholder="Your Name" />
          <input type="email" placeholder="Your Email" />
          <input type="text" placeholder="Your Phone Number" /><br/>
          <textarea placeholder="Your Message"></textarea><br/>
          <button>Send Message</button>
        </div>
      </div> */}
    </div>
  );
}

export default Contact;
